/**
 * A polyfill for lodash's get() function.
 * @param {Object} obj - The object to query.
 * @param {string | Array} path - The path of the property to get.
 * @param {*} [defaultValue] - The value returned if the resolved value is undefined.
 * @returns {*} Returns the resolved value.
 */
export function lodashGet<TObject extends object>(
  obj: TObject,
  path: string | string[],
  defaultValue?: TObject | undefined,
): TObject | undefined {
  const pathArray = Array.isArray(path) ? path : path.split('.');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result = pathArray.reduce((acc, key) => acc && (acc as any)[key], obj);
  return result === undefined ? defaultValue : result;
}
